import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/ContactDetail.css';

const LoadingSpinner = () => {
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div className="loading-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <div className="loading-text">Loading...</div>
    </Container>
  );
};

export default LoadingSpinner; 